import { render, staticRenderFns } from "./ProductSubCategorySelector.vue?vue&type=template&id=40f3da82&scoped=true"
import script from "./ProductSubCategorySelector.vue?vue&type=script&lang=js"
export * from "./ProductSubCategorySelector.vue?vue&type=script&lang=js"
import style0 from "./ProductSubCategorySelector.vue?vue&type=style&index=0&id=40f3da82&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40f3da82",
  null
  
)

export default component.exports